module.exports = __webpack_public_path__ + "media/images/payment/visa-card-75cc43731b6c7f1720a25ff0b7c0c336.png";